import React from "react";
import ReactDOM from "react-dom/client";
import Home from "./Home";
import NoPage from "./NoPage";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<Home />}> */}
        <Route index element={<Home />} />
        <Route path="*" element={<NoPage />} />
        {/* </Route> */}
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
